import Sprite from '../../Sprite';
import Point from '../../../Utility/Point';
import AnimationComponent from '../../../Component/Animation';
import Container from '../../Container';
import GameObject from '../../../GameObject/GameObject';

export default class Crab extends Container {
    protected onCreate(params: any): void {
        params = {
            playOnStart: true,
            clipName: 'CrabIdle',
            ...params,
        };

        super.onCreate({
            name: 'crabContainer',
            scale: new Point(0.7, 0.7),
        });

        this.addChild(
            GameObject.Instantiate(Sprite, {
                name: 'crabLeftHandSprite',
                texture: 'crab_left_hand',
                anchor: new Point(0.5, 0.5),
                position: new Point(34, -6),
                pivot: new Point(-21, 23.5),
            })
        );

        this.addChild(
            GameObject.Instantiate(Sprite, {
                name: 'crabRightHandSprite',
                texture: 'crab_right_hand',
                anchor: new Point(0.5, 0.5),
                position: new Point(-34, -6),
                pivot: new Point(20, 29),
            })
        );

        this.addChild(
            GameObject.Instantiate(Sprite, {
                name: 'crabSprite',
                texture: 'crab',
                anchor: new Point(0.5, 0.5),
            })
        );

        this.addComponent(AnimationComponent, params);
    }
}
